(function() {
    'use strict';

    angular
        .module("ATMGurus")
        .controller("AccountDetailsController", AccountDetailsController);

    AccountDetailsController.$inject = [
    	'User',
    	'$stateParams',
    	'ApiQuery',
    	'AddressBook',
    	'detailsData',
        'Checkout',
        '$state',
        '$window',
        'Cart'
    ];

    function AccountDetailsController(User,  $stateParams,  ApiQuery, AddressBook, detailsData, Checkout, $state, $window, Cart) {

    	this.data = detailsData;	// view data
    	this.report = true;			// confirmaiton.html template hides confirmation related stuff
    	this.error = undefined;
    	this.User = User.getUserData();
        // this.info = this.User.Cart.checkout;
    	this.info = detailsData;
        this.Checkout = detailsData;

        this.status = {
            loading: false
        }

    	this.goBack = function() {
            $window.history.back();
    		// $state.go('^');
    	}

        if ($stateParams.page === 'orders' ) { //|| $stateParams.page === 'repairs') {

            this.status.loading = true;

            ApiQuery("account/orders/" + $stateParams.item, "", "GET")
                .then((response) => {
                    return Cart.init(response.data.data.cart_id)
                })
                .then(() => {
                    return Checkout.init(Cart);
                })
                .then(checkout => {
                    this.Checkout = checkout;
                    this.status.loading = false;
                    var self = this;
                    this.Checkout.Cart.getOrders = function () {
                        var orders = {};
                        // create an array of orders made of a the single order we're looking for
                        var order = self.Checkout.Cart.orders.getOrderById($stateParams.item);
                        orders[order.order_number] = order;
                        return orders;
                    }
                })

        }


    	// adds the item being viewed (order/cart copy) to the current cart
    	this.addToCart = function() {
    		this.loading = true;
    		this.error = undefined;

    		this.endpoint = $stateParams.page === "orders" ? 'account/orders/copy/' + $stateParams.item : 'account/carts/copy/' + $stateParams.item;

    		ApiQuery(this.endpoint, "", "GET")
    			.then(response => {
    				this.loading = false;
    				if (response.data.success) {
                        $state.go('checkout', {cartId: ''})
    				}
                })
                .catch(reason => {
    				this.loading = false;
    				this.error = "Error";
    			})
        }
        
        // non web orders have a cart_id that is negative
        this.isWebOrder = function() {
            return (this.Checkout.Cart.cart_id >= 0);
        }

    }
})()



// WEBPACK FOOTER //
// ./src/app/controllers/AccountDetailsController.js